export const skills = [
  {
    title: "Aptitudes",
    items: [
      "Adaptabilidad",
      "Atención al detalle",
      "Comunicación efectiva",
      "Gestión eficiente del tiempo",
      "Pensamiento analítico",
      "Resolución de problemas",
      "Trabajo colaborativo",
    ],
  },
  {
    title: "Conocimientos",
    items: [
      "Laravel",
      "ExpressJS",
      "React",
      "VueJS",
      "TypeScript",
      "Storybook",
      "Tailwind CSS",
      "SQL",
      "MongoDB",
      "Stripe",
      "Conekta",
      "Shopify",
      "Facturapi",
      "Docker",
      "Git",
      "Figma",
      "Notion",
      "Herramientas de gestión de proyectos",
    ],
  },
  {
    title: "Asistentes de IA",
    items: ["ChatGPT", "Cursor IA"],
  },
];
